var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.188,
    height: 35,
    viewBox: "0 0 46.188 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.188,
    height: 35,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_1",
    "data-name": "Repeat Grid 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-102.6 -232.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M148.433,233l-5.553.656a.38.38,0,0,0-.353.252l-2.171,5.3a.426.426,0,0,0,.454.606l5.553-.606a.38.38,0,0,0,.353-.252l2.171-5.351A.426.426,0,0,0,148.433,233Z",
    transform: "translate(-18.675)",
    fill: "#623CEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M127.375,233.2l-3.685.454a.335.335,0,0,0-.252.2l-1.464,3.483a.289.289,0,0,0,.3.4l3.685-.4a.335.335,0,0,0,.252-.2l1.464-3.533A.323.323,0,0,0,127.375,233.2Z",
    transform: "translate(-9.581 -0.104)",
    fill: "#623CEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M123.84,250.795l-4.8.606a.32.32,0,0,0-.3.252l-1.868,4.594a.42.42,0,0,0,.4.555l4.8-.555a.32.32,0,0,0,.3-.252l1.918-4.644A.438.438,0,0,0,123.84,250.795Z",
    transform: "translate(-7.056 -8.814)",
    fill: "#623CEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M102.6,287.855a11.645,11.645,0,0,0,3.685-5h0c.454-1.161.707-1.969,1.06-2.827.4-1.06,1.464-4.038,2.221-6.057.151-.353.252-.707.353-1.01a1.813,1.813,0,0,1,1.565-1.161l6.966-.3c-.353,1.06-2.675,7.572-2.675,7.572q-.681,1.893-1.211,3.332a7.776,7.776,0,0,1-7.067,5.2Z",
    transform: "translate(0 -19.916)",
    fill: "#623CEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M126.8,279.09a8.508,8.508,0,0,0,3.18-4.24c.959-2.221,3.584-9.641,6.562-18.425a5.4,5.4,0,0,0,.252-.808,2.345,2.345,0,0,1,2.12-1.565l6.512-.252c-.151.5-.757,2.12-1.817,5.3-1.111,3.231-2.978,8.682-4.089,11.812l-.909,2.726a7.767,7.767,0,0,1-2.726,3.735,7.537,7.537,0,0,1-4.341,1.514Z",
    transform: "translate(-11.984 -11.15)",
    fill: "#623CEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M150.5,270.323c2.019-.886,3.281-3.1,4.947-7.873.05-.2,5.805-16.041,8.228-22.585a2.944,2.944,0,0,1,2.726-1.919l6.108-.246c-.707,1.919-6.108,17.271-9.944,27.653a7.393,7.393,0,0,1-6.764,4.822Z",
    transform: "translate(-23.721 -2.332)",
    fill: "#623CEA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/smallLogo.ba84186084f9e1b41760a5ac8b153a36.svg";
export { ForwardRef as ReactComponent };